import React from "react";
import { MDBRow, MDBCol } from 'mdb-react-ui-kit';

export default function Consulenza({
    setTipoRichiesta,
    setMessage,
    }) {

	return (
		<>
            <MDBRow>
                <MDBCol>
                <div className="field">
                    <label className='customLab' >Tipo di Richiesta *</label>
                    <select onChange={e => setTipoRichiesta(e.target.value)} className="select">
                        <option default value="Scegliere">Selezionare un argomento</option>
                        <option value="Comprare casa">Comprare casa</option>
                        <option value="Fare un mutuo">Fare un mutuo</option>
                        <option value="Avviare un'impresa">Avviare un'impresa</option>
                        <option value="Diritto Successorio">Diritto Successorio</option>
                        <option value="Diritto Civile">Diritto Civile</option>
                        <option value="Assistenza Imprese">Assistenza Imprese</option>
                        <option value="Assistenza Privati">Assistenza Privati</option>
                        <option value="Affari Immobiliari">Affari Immobiliari</option>
                        <option value="Assistenza e Difesa degli Enti Pubblici">Assistenza e Difesa degli Enti Pubblici</option>
                        <option value="Altro">Altro</option>
                    </select>
                </div>
                </MDBCol>
            </MDBRow>

            <MDBRow>
                <MDBCol>
                    <div className="field">
                        <label className='customLab' >Richiesta *</label>
                        <textarea className="message-field" type="textarea" placeholder="Inserire dettagli richiesta" name="message" id="message" onChange={e => setMessage(e.target.value)} />
                    </div>
                </MDBCol>
            </MDBRow>
        </>
	);
}